<template>
    <div id="ledger" class="ledger-wrap">
        <!--<h3 class="page-title">培训计划</h3>-->

        <el-form class="page-query" :model="formSearch" :inline="true" size="mini">
            <el-form-item :label="$t('train.name')">
                <el-input v-model="formSearch.name" :placeholder="$t('tip.name')"
                          @keyup.enter.native="getStandingBookData(1)" clearable></el-input>
            </el-form-item>
            <select-multiple :nameArrays="selectNames"
                             v-on:getTrainTypeVal="getTrainTypeVal"
                             v-on:getExamFormVal="getExamFormVal"
                             v-on:getProjectTypeVal="getProjectTypeVal"
                             v-on:getYearTimeVal="getYearTimeVal"
                             v-on:getLedgerOriginVal="getLedgerOriginVal">
            </select-multiple>
            <select-multi-orgs v-model="formSearch.orgIds"></select-multi-orgs>
            <el-form-item label="授课人员">
                <el-input v-model="formSearch.trainer" :placeholder="$t('tip.name')" clearable></el-input>
            </el-form-item>
            <el-form-item label="实施时间">
                <el-date-picker
                    v-model="formSearch.startTime"
                    type="date"
                    :placeholder="$t('tip.startTime')"
                    :picker-options="pickerOptions1"
                    value-format="yyyy-MM-dd">
                </el-date-picker>
                <span> {{$t('c.to')}} </span>
                <el-date-picker
                    v-model="formSearch.endTime"
                    type="date"
                    :placeholder="$t('tip.endTime')"
                    :picker-options="pickerOptions2"
                    value-format="yyyy-MM-dd">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary"  @click="getStandingBookData(1)" round>{{$t('c.query')}}</el-button>
            </el-form-item>
        </el-form>

        <div class="page-table">
            <div class="page-operate">
                <a :href="href" ref="downLoad" id="export-a"></a>
                <el-button-group>
                    <el-tooltip class="item" effect="dark" content="添加台账" placement="top-start"
                                :hide-after="1000">
                        <el-button size="small" @click="$router.push({name: 'addLedger'})">
                            <i class="nucfont inuc-add"></i>
                        </el-button>
                    </el-tooltip>
                    <el-tooltip v-if="isDeleteShow" class="item" effect="dark" :content="$t('c.delete')" placement="top-end"
                                :hide-after="1000">
                        <el-button size="small" :title="$t('c.delete')" @click="deleteStandingBook">
                            <i class="nucfont inuc-delete"></i>
                        </el-button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="导出台账(根据上方筛选条件)" placement="top-start"
                                :hide-after="1000">
                        <el-button size="small" @click="exportLedger">
                            <label class="btn">
                                <i class="nucfont inuc-daochu"></i>
                            </label>
                        </el-button>
                    </el-tooltip>
                </el-button-group>
            </div>

            <data-tables class="form-table"
                         ref="trainTable"
                         :data="tableData"
                         :table-props="tableProps"
                         :current-page.sync="currentPage"
                         :page-size="20"
                         :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                         @selection-change="handleSelectionChange"
            >
                <!-- column checkbox -->
                <el-table-column type="selection" width="55px" :reserve-selection="true" align="center"
                                 :selectable='checkboxInit'></el-table-column>
                <!-- column title -->


                <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.label"
                                 :width="title.width" :min-width="title.minWidth"
                                 align="center"
                                 show-overflow-tooltip
                                 :sortable="title.sortable">
                </el-table-column>

                <el-table-column property="creatorName" :label="$t('c.creator')" align="center"
                                 show-overflow-tooltip sortable></el-table-column>
                <!-- column buttons -->
                <!-- column buttons -->
                <el-table-column :label="$t('c.operation')" align="center" width="150px">
                    <div class="btn-cell" slot-scope="scope">
                        <i class="nucfont inuc-preview"
                           :title="$t('c.view')"
                           @click="viewStandingBook(scope.row)"></i>
                        <i v-if="userInfo.type===1 || userInfo.userID==scope.row.creatorId"
                           :title="$t('c.edit')"
                           class="nucfont inuc-edit"
                           @click="editStandingBook(scope.row)">
                        </i>

                    </div>
                </el-table-column>
            </data-tables>
        </div>

        <transition enter-active-class="animated zoomInRight"
                    leave-active-class="animated zoomOutUp">
            <router-view @onClose="onSubpageClose"></router-view>
        </transition>
    </div>
</template>

<script>
    import api from '@/api';
    import {Ticket} from '@/utils';
    import selectMultiple from '@/components/Selectmultiple';
    import selectMultiOrgs from '@/components/SelectMultiOrgs';
    import config from '@/config'
    import qs from 'qs'

    export default {
        components: {
            selectMultiple,
            selectMultiOrgs
        },
        data() {
            return {
                userInfo: {},
                //删除相关
                isDeleteShow: false,
                //搜索条件相关
                formSearch: {
                    name: '',
                    types: [],
                    projectTypes: [],
                    forms: [],
                    years: [],
                    origins: [],
//                    forlevels: [],
                    orgIds: [],
                    trainer: '',
                    startTime: '',
                    endTime: ''
                },
                tableData: [],
                tableProps: {
                    border: true,
                    stripe: true,
                    rowKey: row => row.id,
                    height: "auto",
                },
                currentPage: 1,
                titles: [
                    {
                        prop: 'name',
                        label: this.$t('train.name'),
                        minWidth: '180px'
                    },
                    {
                        prop: 'typeName',
                        label: this.$t('train.type')
                    }, {
                        prop: 'projectTypeName',
                        label: '项目类别'
                    }, {
                        prop: 'formName',
                        label: this.$t('c.examType')
                    },{
                        prop: 'originName',
                        label: '来源'
                    }, {
                        prop: 'year',
                        label: this.$t('c.yearTime'),
                        sortable: 'custom'
                    }, {
                        prop: 'trainer',
                        label: '授课人员',
                        sortable: 'custom'
                    }, {
                        prop: 'numOfTrainees',
                        label: this.$t('train.memberNum'),
                        sortable: 'custom'
                    }, {
                        prop: 'duration',
                        label: '实施时间',
                        width: '190px',
                        sortable: 'custom'
                    },
                ],
                selectNames: [{
                    key: "trainType",
                },
                    {
                    key: "examForm",
                }, {
                    key: "projectType",
                }, {
                    key: "yearTime",
                }, {
                    key: 'ledgerOrigin',
                }],
                selectPlanId: [],

                // 调研问卷相关
                isSurveyPaper: false,
                radio: undefined,
                surveySearch: {
                    name: undefined,
                },
                surveyPaperData: [],
                surveyTitles: [{
                    prop: 'name',
                    label: this.$t('train.surveyName')
                }, {
                    prop: 'createTime',
                    label: this.$t('c.creationTime')
                }, {
                    prop: 'creatorName',
                    label: this.$t('c.creator')
                }],
                currentPageDialog: 1,
                planID: undefined,
                templateID: undefined,
                isQRCode: false,
                qrValue: '',
                size: 180,
                selectedOrgName: '',
                orgID: '',
                qrCodeDialog: false,
                count: 0,
                expiry:'',
                dialogExtendTime:false,
                dialogForm:{
                    id:0,
                    name:'',
                    endTime:''
                },
                href: '',
            }
        },
        created() {
            if (Ticket.get()) {
                this.userInfo = Ticket.get();
            }
            this.getStandingBookData();
        },
        computed: {
            pickerOptions1() {
                let that = this;
                return {
                    disabledDate(time) {
                        if (!that.formSearch.endTime) return false;
                        return time.getTime() > new Date(that.formSearch.endTime).getTime()
                    },
                }
            },
            pickerOptions2() {
                let that = this;
                return {
                    disabledDate(time) {
                        if (!that.formSearch.startTime) return false;
                        return time.getTime() < new Date(that.formSearch.startTime).getTime()
                    },
                }
            },

        },
        methods: {
            getStandingBookData(page) {
                if(page) this.currentPage = page;
                let queryData = {...this.formSearch};

                ['types', 'forms', 'projectTypes','years'].forEach(v => {
                    if (this.formSearch[v].includes(0)) {
                        delete queryData[v];
                    }
                });
                api.queryStandingBook(queryData).then(res => {
                    let data = res.package;

                    for (let i = 0; i < data.length; i++) {
                        data[i].duration = data[i].startTime.substring(0, 10) + " — "
                            + (data[i].endTime && data[i].endTime.substring(0, 10) || '');
                        data[i].prePublishTime = data[i].prePublishTime?data[i].prePublishTime.substring(0, 16):'-';
                    }

                    this.tableData = data;
                })
            },

            deleteStandingBook() {
                this.$confirm(this.$t('m.delete'), this.$t('m.tip'), {
                    type: 'warning'
                }).then(() => {

                        api.deleteStandingBook({ids: this.selectPlanId}).then((data) => {
                            this.$message({
                                type: 'success',
                                message: this.$t('m.delSuccess')
                            });
                            this.getStandingBookData();
                            this.isDeleteShow = false;
                            this.$refs.trainTable.$refs.elTable.clearSelection();
                        });

                }).catch(() => {
                });
            },
            handleSelectionChange(val) {
                this.selectPlanId = [];
                val.forEach((v, k) => {
                    this.selectPlanId.push(v.id);
                });
                this.selectPlanId.length ? this.isDeleteShow = true : this.isDeleteShow = false;
            },
            checkboxInit(row) {
                return (this.userInfo.type===1) || (row.creatorId === this.userInfo.userID);
            },
            //搜索赋值
            getTrainTypeVal(data) {
                this.formSearch.types = data;
            },
            getExamFormVal(data) {
                this.formSearch.forms = data;
            },
            getProjectTypeVal(data) {
                this.formSearch.projectTypes = data;
            },
            getYearTimeVal(data) {
                this.formSearch.years = data;
            },
            getLedgerOriginVal(data) {
                this.formSearch.origins = data;
            },
            //查看台账
            viewStandingBook(data) {
                this.$router.push({name: 'ledgerDetail', params: {ledgerId: data.id}})
            },
            //编辑台账
            editStandingBook(data) {
                this.$router.push({name: 'editLedger', params: {ledgerId: data.id}})
            },

            exportLedger() {
                const token = Ticket.get().access_token;
                const culture = this.$i18n.locale;

                let queryData = {
                    ...this.formSearch,
                    access_token: token
                };

                ['types', 'forms', 'projectTypes','years'].forEach(v => {
                    if (this.formSearch[v].includes(0)) {
                        delete queryData[v];
                    }
                });

                this.href = APIURI + 'api/Export/excel/standing-book?' + qs.stringify(queryData, {
                    indices: false
                });

                this.$nextTick(() => {
                    $('#export-a')[0].click();
                });
            },

            onSubpageClose() {
                if (Ticket.get()) this.getStandingBookData()
            }
        },
    }
</script>

<style scoped lang="scss">
    @import '../../../style/const.scss';
    .ledger-wrap{
        height: 100%;
    }
    .page-table{
        height: 78%;
    }
    .form-table {
        display: flex;
        flex: 1;
        flex-direction: column;
    }
    .qrcode-wrap {
        margin: 15px 15px 20px 15px;
        .current-org {
            margin-bottom: 15px;
            .org_name {
                color: #2e7faa;
                padding-left: 10px;
            }
        }
        .box {
            display: flex;
            position: relative;

            .left-box {
                width: 280px;
                @include scrollbar();
                border: 1px solid rgb(221, 221, 221);
                .title {
                    background-color: #f4f3f8;
                    border-bottom: 1px solid rgb(221, 221, 221);
                    padding: 5px 10px;
                    .inuc-organization {
                        color: #2e7faa;
                        line-height: 22px;
                    }
                }
                .tree-container {
                    overflow-y: auto;
                    max-height: 460px;
                    background-color: #fff;
                    padding: 12px;
                }

            }
            .QRCode_wrapper {
                margin-left: 20px;
                /*padding-top: 40px;*/
                .btn_generate {
                    /*text-align: center;*/
                    cursor: pointer;
                    margin-bottom: 30px;
                    display: flex;
                    .due-title{
                        line-height: 40px;
                        margin-right: 5px;
                    }
                    .qr-make {
                        padding: 10px 25px 10px 20px;
                        //background: linear-gradient(#70a2ff, #23c4d9);
                        background-color:#22B9FF;
                        color: #fff;
                        border-radius: 4px;
                        position: relative;
                        margin-left: 15px;
                        i {
                            font-size: 28px;
                            position: absolute;
                            right: 8px;
                            top: 5px;
                            animation: clickmove 1s infinite;
                            -webkit-animation: clickmove 1s infinite alternate;
                        }
                    }
                }
                .QRCode_box {
                    width: 180px;
                    height: 180px;
                    //border: 2px solid #0a8ddf;
                    border-radius: 4px;
                    margin: 0 auto;
                    position: relative;
                    background: radial-gradient(#84d6fe, #269bea);
                    .centerimg {
                        border: 1px solid #fff;
                        width: 40px;
                        height: 40px;
                        position: absolute;
                        margin-left: -16px;
                        margin-top: -16px;
                        left: 50%;
                        top: 50%;
                        z-index: 100;
                    }
                    .tipinfo {
                        width: 120px;
                        height: 40px;
                        position: absolute;
                        margin-top: -16px;
                        top: 45%;
                        left: 50%;
                        margin-left: -60px;
                        text-align: center;
                        z-index: 100;
                        color: #fff;
                    }
                }
            }

        }
    }
    .m-trainPlan {
        .survey-paper {
            & /deep/ .el-table__body-wrapper{
                height: 300px;
            }
            & /deep/ .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
                box-shadow: none;
            }
        }
    }

    .progress {
        display: inline-block;
        width: 60px;
        background-color: #2FC0A1;
        color: #fff;
        text-align: center;
        border-radius: 10px;
    }
    .extend-tip{
        margin-left: 58px;
        color: #9f9f9f;
        margin-bottom: 20px;
        >p{
            line-height: 26px;
        }
    }
    @keyframes clickmove {
        0% {
            transform: scale(0.7, 0.7);
        }
        100% {
            transform: scale(1.3, 1.3);
        }
    }
</style>
